const volunteerData = [
  {
    id: 1,
    icon: "/images/volunteer-image-2.png",
    alt: "أيقونة التنمية الإدارية وبناء القدرات",
    title: "التنمية الإدارية وبناء القدرات",
    description:
      "المشاركة في برامج تدريبية واستشارية تهدف إلى رفع كفاءة الأفراد والمؤسسات، وتطوير مهاراتهم الإدارية والتنظيمية لتحقيق أداء أفضل.",
  },
  {
    id: 2,
    icon: "/images/volunteer-image-1.png",
    alt: "أيقونة الدعم التقني والتحول الرقمي",
    title: "الدعم التقني والتحول الرقمي",
    description:
      "المساعدة في تقديم حلول تقنية للجهات والمؤسسات، مثل إدارة الأنظمة، تطوير المواقع والتطبيقات ، أو تدريب الفرق على استخدام الأدوات الرقمية الحديثة.",
  },
  {
    id: 3,
    icon: "/images/volunteer-image-3.png",
    alt: "أيقونة الخدمة المؤسساتية",
    title: "الخدمة المؤسساتية",
    description:
      "المساهمة في مبادرات مؤسساتية وخدمات مجتمعية تعزز التنمية المحلية وتلبي احتياجات المجتمع بشكل مستدام.",
  },
  {
    id: 4,
    icon: "/images/volunteer-image-4.png",
    alt: "أيقونة مشاريع وزارية",
    title: "مشاريع وزارية",
    description:
      "المشاركة في مبادرات ومشاريع وزارية تدعم المجالات التعليمية والصحية والخدمية، وتسهم في تحسين جودة الخدمات العامة.",
  },
];

export default volunteerData;